module.exports = __webpack_public_path__ + "img/stock7.62e30a75.png";